<template>
  <div class="filter">
    <div class="filter__self">
      <a-icon
        @click="removeChild(index, parent)"
        class="filter__button"
        type="delete"
      />
      <a-icon
        @click="addChild(filter.children)"
        class="filter__button"
        type="plus"
      />
      <a-select
        v-if="index > 0"
        class="filter__cond"
        v-model="filter.condition"
        :dropdownMatchSelectWidth="false"
      >
        <a-select-option value="OR">ИЛИ</a-select-option>
        <a-select-option value="AND">И</a-select-option>
      </a-select>
      <a-select
        class="filter__column"
        v-model="filter.column"
        :dropdownMatchSelectWidth="false"
      >
        <a-select-option
          v-for="column in columns"
          :value="column.name"
          :key="column.id"
          >{{ column.gui_name || column.name }}</a-select-option
        >
      </a-select>
      <a-select
        class="filter__operator"
        v-model="filter.operator"
        :dropdownMatchSelectWidth="false"
      >
        <a-select-option
          v-for="(word, operator) in operators"
          :value="operator"
          :key="operator"
        >
          {{ word }}
        </a-select-option>
      </a-select>
      <a-input
        @keyup.enter.native="$emit('submit')"
        v-if="filter.operator !== 'IS'"
        v-model="filter.value"
        class="filter__input"
      ></a-input>
      <a-select v-else v-model="filter.value" class="filter__input">
        <a-select-option value="NULL">Пустым</a-select-option>
        <a-select-option value="NOT NULL">Заполненным</a-select-option>
      </a-select>
    </div>
    <div class="filter__footer">
      <a-select
        v-if="filter.children.length"
        class="filter__cond filter__cond_f"
        v-model="filter.childCondition"
        :dropdownMatchSelectWidth="false"
      >
        <a-select-option value="OR">ИЛИ</a-select-option>
        <a-select-option value="AND">И</a-select-option>
      </a-select>
      <div class="filter__children">
        <row
          @submit="$emit('submit')"
          @addChild="addChild"
          @removeChild="removeChild"
          v-for="(child, index) in filter.children"
          :index="index"
          :parent="filter"
          :filter="child"
          :operators="operators"
          :columns="columns"
          :key="index"
        />
      </div>
    </div>
  </div>
</template>

<script>
// eslint-disable-next-line
import Row from './Row.vue';

export default {
  name: 'row',
  components: { Row },
  props: ['index', 'filter', 'operators', 'columns', 'parent'],
  methods: {
    addChild(children) {
      this.$emit('addChild', children);
    },
    removeChild(index, parent) {
      this.$emit('removeChild', index, parent);
    },
  },
  watch: {
    // eslint-disable-next-line
    'filter.operator': function (newVal, oldVal) {
      if (oldVal === 'IS') {
        this.filter.value = '';
      } else if (newVal === 'IS') {
        this.filter.value = 'NULL';
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.filter {
  &__self {
    display: flex;
    align-items: center;
    margin-bottom: 8px;
  }

  &__footer {
    padding-left: 42px;
    display: flex;
    align-items: flex-start;
  }

  &__children {
    flex-grow: 1;
    padding-left: 10px;
    border-left: 1px solid #ccc;
    position: relative;

    &:before {
      content: "";
      display: block;
      position: absolute;
      height: 8px;
      width: 1px;
      background-color: #fff;
      left: -1px;
      bottom: 0;
    }
  }

  &__button {
    cursor: pointer;
    margin-right: 5px;
  }

  &__operator {
    margin: 0 5px;
  }

  &__cond {
    margin-right: 5px;

    &_f {
      margin-right: 10px;
    }
  }

  &__input {
    flex-grow: 1;
  }
}
</style>
